import * as React from 'react';

import { AuthorCallReasons } from 'shared/components/AuthorCallReasons/AuthorCallReasons';
import { PhonesContainer } from 'shared/containers/AuthorCallReasons/parts/PhonesContainer';

export const AuthorCallReasonsContainer = ({ reasons }: { reasons: string[] }) => {
  return (
    <AuthorCallReasons
      reasons={reasons}
      contactsButton={<PhonesContainer trackingAction="Open_card_more_block" size="XS" />}
    />
  );
};
